<template>
  <div>
    <v-dialog v-model="dialog" max-width="800" scrollable>
      <v-card>
        <div class="orangeCardTitle pa-3">
          <div class="d-flex flex-row flex-wrap">
            <div class="text-h5">
              Lens Type Advice ({{ eye.toUpperCase() }})
            </div>

            <v-spacer></v-spacer>
            <v-btn color="primary" icon @click.stop="$emit('close')">
              <v-icon color="primary">mdi-close</v-icon></v-btn
            >
          </div>
          <div class="caption">
            <div v-if="!calcResults || !calcResults[eye]">
              (This window can provide more customized advice after you input
              refractions and keratometry)
            </div>
            <div v-else>
              <div class="ml-3" v-if="rxString">
                {{ eye.toUpperCase() }} Rx: {{ rxString }}
              </div>
              <div class="ml-3" v-if="kString">
                {{ eye.toUpperCase() }} Ks: {{ kString }}
              </div>
            </div>
          </div>
        </div>

        <v-card-text class="mt-2 darkerCardText px-1 px-sm-2">
          <v-card
            v-for="calcGroup in calcGroups"
            :key="calcGroup.group"
            class="mb-4"
            flat
            style="border: 1px solid #8eb4ca"
          >
            <div class="groupHeader pa-2">
              <div class="title d-flex flex-row py-2">
                <v-img
                  max-width="30"
                  max-height="30"
                  contain
                  :src="calcGroup.icon"
                  class="mr-2"
                ></v-img>
                {{ calcGroup.name }}
              </div>
              <div class="">{{ calcGroup.advice }}</div>
            </div>
            <v-data-table
              :headers="headers"
              :items="itemsByGroup[calcGroup.group]"
              hide-default-footer
              class="mt-4 mx-1"
            >
              <template v-slot:item.name="{ item }">
                <simple-popover v-if="item.advice" :title="item.name"
                  ><template #activator>
                    <div class="font-weight-bold">
                      {{ item.name }}
                      <v-icon x-small color="primary" class="ml-1">
                        mdi-information-outline
                      </v-icon>
                    </div></template
                  ><template #content
                    ><div v-html="item.advice"></div
                  ></template>
                </simple-popover>

                <div v-else class="font-weight-bold">
                  {{ item.name }}
                </div>
              </template>
              <template v-slot:item.score="{ item }">
                <div
                  v-if="item.score != undefined"
                  class="title"
                  :style="{
                    color: scoreColor(item.score),
                  }"
                >
                  {{ item.score }}
                </div>
              </template>
              <template v-slot:item.advice="{ item }">
                <div v-if="item.advice" v-html="item.advice"></div>
              </template>
              <template v-slot:item.isGoodChoiceShort="{ item }">
                <div
                  v-if="item.isGoodChoiceShort"
                  class="highlight"
                  v-html="item.isGoodChoiceShort"
                ></div>
              </template>
              <template v-slot:item.choose="{ item }">
                <v-btn
                  small
                  depressed
                  rounded
                  color="primary"
                  @click="$emit('lensType', item.lensKey)"
                >
                  choose</v-btn
                >
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";
import StyleUtilities from "@/assets/js/StyleUtilities";
import RxMethods from "@/assets/js/cls/RxMethods";
import SimplePopover from "@/components/universalStuff/SimplePopover";

export default {
  name: "ClCalcsAdvice",

  props: {
    calcGroups: null,
    calcOptions: null,
    calcResults: null,
    dialog: null,
    eye: null,
    rxObjects: null,
    kObjects: null,
  },
  mixins: [StyleUtilities, RxMethods],
  components: { SimplePopover },
  data: function () {
    return {
      // eyeAdvice: null,
      headers: [
        { text: "Name", value: "name", align: "start" },
        // { text: "Advice", value: "advice" },
        { text: "Score", value: "score", align: "start" },
        { text: "Good Choice?", value: "isGoodChoiceShort", align: "start" },
        { text: "", value: "choose", align: "start" },
      ],
    };
  },
  methods: {
    scoreColor(scoreNum) {
      let percent = scoreNum / 10;
      return this.percentageToHsl(percent, 0, 120);
    },
  },
  computed: {
    rxString: function () {
      let obj = this.rxObjects?.[this.eye];
      if (!obj) return null;
      return this.prettyString(this.rxObjects[this.eye]);
    },
    kString: function () {
      let obj = this.kObjects?.[this.eye];
      if (!obj) return null;
      return this.prettyFullKstring(this.kObjects[this.eye]);
    },

    itemsByGroup: function () {
      let rtn = {};
      if (!this.calcGroups) return rtn;
      let calcOptions = this.calcOptions;
      let calcResults = this.calcResults;
      let eye = this.eye;
      this.calcGroups.forEach((groupObj) => {
        // let rtnObj = { score: null, isGoodChoiceShort: null };
        let groupKey = groupObj.group;
        rtn[groupKey] = [];
        groupObj.items.forEach((lensKey) => {
          let lensObj = calcOptions[lensKey];
          lensObj.lensKey = lensKey;
          let calcObj = calcResults?.[eye]?.[lensKey];
          rtn[groupKey].push({ ...lensObj, ...calcObj });
        });
      });

      return rtn;
    },
  },
  watch: {
    // eye: function (val) {
    //   if (val) {
    //     this.eyeAdvice = val;
    //   }
    // },
  },
};
</script>

<style scoped>
/* .highlight {
  padding: 0.5em;
  margin: 0.5em;
  background-color: #fdeec9;
} */
.groupHeader {
  background-color: #edf8ff;
  border-bottom: 1px solid #8eb4ca;
}
</style>
